import { FC } from 'react';
import { useInviteData } from './invite.hook';

/**
 * Invite component
 * @description Content for the UsersManagement Invite flow.
 * @link https://www.figma.com/file/PiyMHA6tRkvaEpfgDnzUPI/Administrator--%7C-File-for-development?type=design&node-id=1525-47586&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const Invite: FC = () => {
  const { stages, currentStage } = useInviteData();

  return stages && currentStage ? stages[currentStage] : null;
};

export { Invite };
